//
//
//
//

  import { store } from "./store"
  import { mapStyle } from "./constants"
  import infobox from 'google-maps-infobox/infobox-module'
  
  const initial_zoom_level = 9;
  const initial_center = [52.7,4.2];
  const initialMarkerData = JSON.parse(window.__INITIAL_STATE_PROJECTS__) || {};

  store.initialMarkerData = initialMarkerData

  export default {
    name: 'google-map',
    props: ['name'],
    data: function() {
      return {
        mapName: this.name + "-map",
        markerData: initialMarkerData,
        map: null,
        bounds: null,
        markers: [],
        visibleMarkers: [],
        overlappingMarkers: [],
        visibleOverlappingMarkers: [],
        filter: {
          'gemeente':[],
          'sector':[],
          'typeactiviteit':[],
          'onsnetwerk':[],
          'initial_center':[],
          'kopvannoord_holland':[],
        },
        infoBox: null,
      }
    },
    mounted() {
      this.bounds = new window.google.maps.LatLngBounds();

      const element = document.getElementById(this.mapName)
      const options = {
        zoom: initial_zoom_level,
        center: new window.google.maps.LatLng(initial_center[0], initial_center[1]),
        styles: mapStyle,
        mapTypeControl: false,
      }
      // create the map
      this.map = new window.google.maps.Map(element, options);

      // add markers
      this.markerData.forEach((m) => {
        const position = new window.google.maps.LatLng(m._mapping_project_latitude,m._mapping_project_longitude)
        const marker = new window.google.maps.Marker({
          position, 
          icon: m.icon,
          map: this.map,
          post_id:                         m.post_id,
          _mapping_project_id:             m._mapping_project_id,
          _mapping_project_latitude:       m._mapping_project_latitude,
          _mapping_project_longitude:      m._mapping_project_longitude,
          _mapping_project_gemeente:       m._mapping_project_gemeente,
          _mapping_project_subregio:       m._mapping_project_subregio,
          _mapping_project_sector:         m._mapping_project_sector,
          _mapping_project_typeactiviteit: m._mapping_project_typeactiviteit,
          _mapping_project_onsnetwerk:     m._mapping_project_onsnetwerk,
          infobox_content: '<div class="infobox-content" data-project-id="'+m._mapping_project_id+'"><img src="'+m.image+'"><p>'+m.post_title+'</p><a href="javascript:void(0)" class="meerinfo">meer info</a></div>',
        })

        marker.addListener('click', () => markerClickHandler(marker))
        this.markers.push(marker)
        // this.map.fitBounds(this.bounds.extend(position))
      })
      // this.fitBoundsToVisibleMarkers()

   
      // Add an Google Map infoBox
      this.infoBox = new infobox.InfoBox({
          content: "",
          closeBoxURL: "",
          pixelOffset: new window.google.maps.Size(26, -26),
          boxClass: "",
          enableEventPropagation : false, // do not pass clicks on to google map
          boxStyle: {
            textAlign: "center",
          },
        })


      // Click on map hides the infoBox
      this.map.addListener('click', () => {
        this.infoBox.close()
      })

      this.infoBox.addListener("domready", () => {
        
        // adds click handler for single and multiple markers
        $(".infobox-content").on("click", () => { 
          let el = $('.infobox-content')
          let project_id = false
          let related_projects = []

          // click on slider?
          if(el.hasClass('slick-slide')) {
                       
            $('.slick-slide:not(.slick-cloned)').each(function(){
              // store project-id
              if( $(this).data('project-id') !== undefined ) {
                related_projects.push($(this).data('project-id'));
              }

              // if this is the current visisble slide, pass this project_id
              if($(this).hasClass('slick-current')) {
                project_id = $(this).data('project-id')
              }
            })

          } else {
            // click on single marker
            if(el.data('project-id') !== undefined) {
              project_id = el.data('project-id')
              related_projects.push(el.data('project-id'))
            }
          }

          if(project_id) {
            // open the detail panel
            this.$root.$emit('clickOnPopUp', {project_id, related_projects})
          }
        })

        // adds slick-slider for multiple markers
        var $status = $('.pagingInfo');
        var $slickElement = $('#slick-slider');

        $slickElement.on('init reInit afterChange', function(event, slick, currentSlide){
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });

        $slickElement.slick({
          asNavFor: '#panel-detail',
        });

      })

      // define function for click on marker
      const markerClickHandler = (marker) => {
        
        // move and open the infobox
        this.infoBox.close()
        this.infoBox.setContent(marker.infobox_content)
        this.infoBox.setPosition(marker.position)
        this.infoBox.open(this.map, marker)

        this.$root.$emit('hideDetailPanel') // emit to PanelDetail
      }

      // listen to clicks on filters
      this.$root.$on('updateGoogleMap', this.applyFilters)

    },
    methods: {
      applyFilters() {
/*eslint-disable no-unused-vars*/
        
        this.visibleMarkers.length = 0
        this.infoBox.close()
        
        this.markers.forEach((m) => {
          let pass_gemeente = false
          let pass_sector = false
          let pass_typeactiviteit = false
          let pass_onsnetwerk = false
          let pass_post_id = false
          let f = []

          // gemeente
          f = store.getFilterValues('gemeente')

          if(f.length != 0) {
            m._mapping_project_gemeente.filter((x) => {
              if((f).indexOf(x)!=-1) {
                pass_gemeente = true
              }
            })
          } else {
            pass_gemeente = true
          }

          // sector
          f = store.getFilterValues('sector')

          if(f.length != 0) {
            m._mapping_project_sector.filter((x) => {
              if((f).indexOf(x)!=-1) {
                pass_sector = true
              }
            })
          } else {
            pass_sector = true
          }

          // typeactiviteit
          f = store.getFilterValues('typeactiviteit')
          
          if(f.length != 0) {
            m._mapping_project_typeactiviteit.filter((x) => {
              if((f).indexOf(x)!=-1) {
                pass_typeactiviteit = true
              }
            })
          } else {
            pass_typeactiviteit = true
          }

          // onsnetwerk
          f = store.getFilterValues('onsnetwerk')

          if(f.length != 0) {
            m._mapping_project_onsnetwerk.filter((x) => {
              if((f).indexOf(x)!=-1) {
                pass_onsnetwerk = true
              }
            })
          } else {
            pass_onsnetwerk = true
          }
          
          // post_id
          f = store.getFilterValues('post_id')

          if(f.length != 0) {
            if((f).indexOf(m.post_id)!=-1) {
              pass_post_id = true
            }
          } else {
            pass_post_id = true
          }

          if( pass_gemeente && pass_sector && pass_typeactiviteit && pass_onsnetwerk  && pass_post_id) {
            m.setVisible(true)
            this.visibleMarkers.push(m)
          } else {
            m.setVisible(false)
          }
        })

        if(this.visibleMarkers.length) {
          this.addOverlappingMarkers()
          this.fitBoundsToVisibleMarkers()

          // if all markers are visible apply startup values
          if(this.markers.length === this.visibleMarkers.length) {
            this.map.setOptions({
              zoom: initial_zoom_level,
              center: new window.google.maps.LatLng(initial_center[0], initial_center[1]),
            })
          }
        }
        else {
          // No results
          this.map.setOptions({
            zoom: initial_zoom_level,
            center: new window.google.maps.LatLng(initial_center[0], initial_center[1]),
          })
          this.addOverlappingMarkers()
        }
        
      },
      addOverlappingMarkers() {
        // remove all overlapping markers 
        this.visibleOverlappingMarkers.forEach((m,index) => {
          this.visibleOverlappingMarkers[index].setMap(null)
        })
        this.overlappingMarkers.length = 0
        this.visibleOverlappingMarkers.length = 0

        // search for visible markers with the same latitude and longitude
        this.visibleMarkers.forEach((m) => {
          
          let key = m._mapping_project_latitude + ',' + m._mapping_project_longitude

          // search for existing key
          let f = this.overlappingMarkers.find(x => x.position === key)
          if (f === undefined) {
            // create new entry for this position
            this.overlappingMarkers.push({position:key, values:[m]})
          } else {
            // update the values for this position
            f.values.push(m)
          }          

        })
        // cleanup: we only want positions with more than 1 marker
        if(this.overlappingMarkers.length) {
          this.overlappingMarkers = this.overlappingMarkers.filter(x => x.values.length > 1)
        }
        // add markers
        if(this.overlappingMarkers.length) {
          this.overlappingMarkers.forEach((m,index) => {
            
            let arr = m.position.split(',');
            const position = new window.google.maps.LatLng(arr[0],arr[1])
            
            // create a stack of all infobox_content divs 
            let _infobox_content = '';
            m.values.forEach((v) => {
              _infobox_content += v.infobox_content
            })

            const marker = new window.google.maps.Marker({
              position, 
              icon: '/app/themes/mapping/dist/images/icons/markers/marker_multiple.png',
              map: this.map,
              label: {fontWeight: "bold", text: m.values.length.toString()},
              zIndex: 100 + index,
              pixelOffset: new window.google.maps.Size(26, -26),
              infobox_content: '<div class="slick-slider-container"><div class="pagingInfo"></div><div id="slick-slider">'+_infobox_content+'</div></div>', 
            })
            
            marker.addListener('click', () => this.overlappingMarkerClickHandler(marker))
            this.visibleOverlappingMarkers.push(marker)

          })
        }

        
      },
      // define function for click on marker
      overlappingMarkerClickHandler(marker) {
        // move and open the infobox
        this.infoBox.close()
        this.infoBox.setContent(marker.infobox_content)
        this.infoBox.setPosition(marker.position)
        this.infoBox.open(this.map, marker)
        this.$root.$emit('hideDetailPanel') // emit to PanelDetail
      },


      fitBoundsToVisibleMarkers() {        
        const bounds = new window.google.maps.LatLngBounds()

        this.markers.forEach((m) => {
          if( m.getVisible() ) {
            bounds.extend( m.getPosition() );
          }
        })
        
        this.map.fitBounds(bounds)
       
        if(this.map.getZoom() > 15) this.map.setZoom(15)
      },

    },
  }


 /* 
 myMarkers = [
  {
    position: {
      lat: 52.294235,
      lng: 4.889183,
    },
    icon: "https://localhost:3000/app/themes/mapping/dist/images/icons/markers/marker_water_regionalesamenwerking.png",
  }, {
    position: {
      lat: 11.0,
      lng: 11.0,
    },
  }];
*/



// WEBPACK FOOTER //
// ./scripts/vue/GoogleMap.vue